import React, { PropsWithChildren } from 'react'
import { SearchResultPartyDetails } from '@Entities/party-details'

interface WriterSelectionCardProps {
    writer: SearchResultPartyDetails
}

const WriterSelectionCard = ({ writer, children }: PropsWithChildren<WriterSelectionCardProps>) => (
    <div className="writer-selection-card">
        <div className="writer-selection-card-header">
            {children}
            <span className="writer-selection-card-name">{writer.name}</span>
        </div>
        <div className="writer-selection-card-ipi">
            <span>IPI:</span> <b>{writer.ipiNumber}</b>
        </div>
    </div>
)

export default WriterSelectionCard
